import pegasus from "../../build/global/js/00-pegasus";

window.ipDetectionBar = () => {
    return {
        visible: false,
        matchingLocation: true,
        show:true,
        selector: null,
        shouldView: null,
        init() {
            this.selector = document.getElementById('ip-select');

            pegasus.selectField(this.selector, {
                openOnHover: false,
                firstItemDisabled: true,
                classNames: {
                    outerWrapper:   '',
                    selector:       'Form__Selector w-full cursor-pointer relative border border-[#1A1A1A] rounded-full py-2 pl-4 pr-8 focus:outline-none max-w-[286px]',
                    selectorOpen:   '-open',
                    selectionList:  'Select_Scroll-Box w-full border bg-[#F9F7F4] border-[#1A1A1A] rounded-3xl',
                    listItem:       'body-small select-none relative transition duration-300 py-2 px-4 flex',
                    listItemFocus:  'text-[#1A1A1A] opacity-60',
                }
            });

            this.getIPInfo();
        },
        territorySelect(href, territory = null)
        {
            const selectorOptions = this.selector.querySelectorAll('option');
            const selectedTerritory = territory === null ? selectorOptions[this.selector.selectedIndex].dataset.territoryId : territory;
            
            pegasus.setCookie('IP_VERIFIED', JSON.stringify({territory: selectedTerritory}));
            window.location.href = href;
        },
        getIPInfo() {
            let IPCookie;

            if (pegasus.getCookie('IP_VERIFIED') !== undefined) {
                IPCookie = pegasus.getCookie('IP_VERIFIED');
            }

            const data = new FormData();
            data.append('action', 'ip_detect_notify');
            data.append('url', window.location.href);

            fetch(ajaxurl, {
                method: 'POST',
                credentials: 'same-origin',
                body: data
            }).then(async resp => {
                const data = await resp.json();

                if (data.current_view !== undefined) {
                    this.currentView = data.current_view;
                }

                if (data.should_view !== undefined) {
                    this.shouldView = data.should_view;
                }

                if (typeof IPCookie !== 'undefined' && IPCookie !== '') {
                    IPCookie = JSON.parse(IPCookie);

                    if (parseInt(IPCookie.territory) === data.current_view) {
                        data.show_bar = false;
                    }

                    this.territory = parseInt(IPCookie.territory);
                }

                if (data.show_bar !== undefined) {
                    this.matchingLocation = !data.show_bar;

                    setTimeout(() => {
                        this.show = data.show_bar;
                    }, 500)

                }

                return data

            }).then(data => {

                if(this.matchingLocation === false){
                    if(typeof IPCookie !== 'undefined' && IPCookie !== ''){
                        if (parseInt(IPCookie.territory) === parseInt(document.body.dataset.territory)) {
                            this.matchingLocation = true;
                            this.show = false;
                        }
                    }

                    const countrySelector = this.$root.querySelector('select');

                    countrySelector.value = data.should_view_home;

                    // If shouldView is set, show it in the dropdown
                    if (this.shouldView) {
                        Array.from(countrySelector.options).forEach(option => {
                            if (option.dataset.territoryId == this.shouldView) {
                                option.selected = true;
                            }
                        });

                        countrySelector.dispatchEvent(new Event('change'));
                    }
                }
            });

        }

    }
}
